import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getProduct = createAsyncThunk('fetchProduct', async (id, thunkAPI) => {
    return axios
        .get(`http://127.0.0.1:8000/main/product/${id}/`) 
        .then(response => response.data)
        .catch(err => err.message)
})

export const fetchProductSlice = createSlice({
    name: 'fetchProduct',
    initialState: {
        loading: false,
        product: '',
        error: ''
    },
    reducers: {

    },
    extraReducers: builder => {
        builder.addCase(getProduct.pending, state => {
            state.loading = true
        })
        builder.addCase(getProduct.fulfilled, (state, action) => {
            state.loading = false
            state.product = action.payload
            state.error = ''
        })
        builder.addCase(getProduct.rejected, (state, action) => {
            state.loading = false
            state.error = action.error.message
        })
    }
})

export default fetchProductSlice.reducer